import React from 'react';
import cn from 'classname';
import './index.less';

function PayoutStatus({ status }) {
	return (
		<div className={cn('payout-table--body--status', status)}>
			{status}
		</div>
	);
}

export default PayoutStatus;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-status/index.js